//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {},
  methods: {
    toggleSetting(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    labelIcon(labelId) {
      return this.$root.selectedLabels?.includes(labelId)
        ? "check_box"
        : "check_box_outline_blank";
    },
    toggleLabel(labelId) {
      if (this.$root.selectedLabels.includes(labelId)) {
        let idx = this.$root.selectedLabels.indexOf(labelId);
        this.$root.selectedLabels.splice(idx, 1);
      } else {
        this.$root.selectedLabels.push(labelId);
      }
    },
  },
  mounted() {
    this.$root.$on("filtering-dialog", (data) => {
      this.showDialog = true;
    });
  },
};
